import React, { useMemo } from 'react';
import styled from 'styled-components';

import { H2, BodyLarge, H4 } from '@styled';
import colors from '@general/colors';
import useViewer from '@hooks/useViewer';

const ContainerStyled = styled.div`
    align-items: center;
    border: 6px solid ${colors.admiral};
    display: flex;
    height: 600px;
    position: relative;
`;

const LogoContainerStyled = styled.div`
    position: absolute;
    right: 20px;
    top: 40px;
`;

const LogoImgStyled = styled.img`
    width: 120px;
`;

const EventBadge = () => {
    const { viewer } = useViewer();
    const memberAddress = useMemo(() => {
        if (!viewer?.addresses) {
            return null;
        }

        return viewer.addresses.find(address => address.purpose === 'main') || null;
    }, [viewer]);

    if (!viewer) {
        return null;
    }

    return (
        <ContainerStyled>
            <LogoContainerStyled>
                <LogoImgStyled src="/assets/images/ICSC-logo-2023.svg" />
            </LogoContainerStyled>

            <div className="pt-2rem text-center w-full">
                <H2>{(viewer.informal || viewer.firstName).toUpperCase()}</H2>
                {viewer.lastName && <H4 className="mt-2rem">{viewer.lastName}</H4>}
                {viewer?.company?.name && <H4 className="mt-2rem">{viewer.company.name}</H4>}
                {memberAddress && (
                    <BodyLarge className="mt-0.5rem">
                        {memberAddress.city}, {memberAddress.stateProvince}
                    </BodyLarge>
                )}
            </div>
        </ContainerStyled>
    );
};

EventBadge.propTypes = {
    //
};

export default EventBadge;
